import { queryOptions, useQuery } from "@tanstack/react-query";
import {
  type CalculateParams,
  calculateTransaction,
  getTransaction,
  type SearchTransactionsParams,
  searchTransactions,
} from "./services";

export const pointTransactionKeys = {
  all: ["point-transactions"] as const,
  search: (params: SearchTransactionsParams) =>
    [...pointTransactionKeys.all, "search", params] as const,
  detail: (id: string) => [...pointTransactionKeys.all, "detail", id] as const,
  calculation: (params: CalculateParams) =>
    [...pointTransactionKeys.all, "calculation", params] as const,
};

export function transactionOptions(id: string) {
  return queryOptions({
    queryKey: pointTransactionKeys.detail(id),
    queryFn: () => getTransaction(id),
  });
}

export function useTransactionQuery(id: string | null) {
  return useQuery({
    queryKey: pointTransactionKeys.detail(id ?? ""),
    queryFn: () => getTransaction(id!),
    enabled: id !== null,
  });
}

export function calculationOptions(params: CalculateParams) {
  return queryOptions({
    queryKey: pointTransactionKeys.calculation(params),
    queryFn: () => calculateTransaction(params),
    enabled:
      !!params.loyalty_account_id &&
      (params.purchase_value_cents > 0 || (params.points !== undefined && params.points !== 0)),
  });
}

export function useCalculationQuery(params: CalculateParams) {
  return useQuery(calculationOptions(params));
}

export function searchTransactionsOptions(params: SearchTransactionsParams) {
  return queryOptions({
    queryKey: pointTransactionKeys.search(params),
    queryFn: () => searchTransactions(params),
    staleTime: 30_000,
  });
}

export function useSearchTransactionsQuery(params: SearchTransactionsParams) {
  return useQuery(searchTransactionsOptions(params));
}
